// removed by extract-text-webpack-plugin
module.exports = {"mainContent":"CgbCqjzXwl4516HXKzEZS"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/simplified/mobile/css/main.css
// module id = 998
// module chunks = 0